export default {
  logo: require("../assets/images/benevv_logo.png"),
  onboardingOne: require("../assets/images/onboarding-1.png"),
  onboardingTwo: require("../assets/images/onboarding-2.png"),
  onboardingThree: require("../assets/images/onboarding-3.png"),
  userTypeMyself: require("../assets/images/user-type-myself.png"),
  userTypeBrand: require("../assets/images/user-type-brand.png"),
  userTypeNonprofit: require("../assets/images/user-type-nonprofit.png"),
  planEntrepreneurLite: require("assets/images/props-plans/business/props-entrepreneur-lite.png"),
  planPremium: require("../assets/images/props-plans/business/props-premium.png"),
  planEnterprise: require("../assets/images/props-plans/business/props-enterprise.png"),
  planPremiere: require("../assets/images/props-plans/school/props-premiere.png"),
  planElite: require("../assets/images/props-plans/school/props-elite.png"),
  planSuperStar: require("../assets/images/props-plans/school/props-super-star.png"),
  planFamily: require("../assets/images/props-plans/family/props-family-plan.png"),
  paymentsThankYou: require("../assets/images/thank-you.png"),
  paymentsErrorPopup: require("../assets/images/oops_error.png"),
  propsLogo: require("../assets/images/props-logo-white.png"),
  benevvLogo: require("../assets/images/benevv_logo.png"),
  saveIcon: require("../assets/images/icons/save_icon.png"),
  shareIcon: require("../assets/images/icons/share_icon.png"),
  likeIcon: require("../assets/images/icons/like_icon.png"),
  likesGroup: require("../assets/images/icons/likes_group.png"),
  messageIcon: require("../assets/images/icons/message_icon.png"),
  closeIcon: require("../assets/images/icons/close_icon.png"),
  noEvent: require("../assets/images/no_events.png"),
  DEFAULT_AVATAR: "https://cdn-icons-png.flaticon.com/512/149/149071.png",
};
